import React, {
  useState,
  useContext,
  useEffect
}                                 from 'react';
import { historyPropType }        from '~/config/routerPropTypes';
import { showSubscription }       from '~/config/routes';
import Request                    from '~/providers/Request';
import Subscription               from './context';
import SubscriptionRecord         from '~/records/SubscriptionRecord';
import Form                       from './Form';

function EditRecord({history}){
  const [ record, setRecord] = useState(new SubscriptionRecord());
  const [ loading, setLoading] = useState(false);
  const { records, addRecords } = useContext(Subscription);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      if(records && records[id]){
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/plans/${id}`, {})
        .then( response => {
          setLoading(false);
          addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  async function onSubmit (){
    const data = record.toParams();
    setLoading(true);
    Request.put(`/admin/plans/${id}`, data, {}, { controller: 'plans' })
    .then((e) => {
      setLoading(false);
      history.push(showSubscription.reverse(e.data));
    })
    .catch(e => {console.error(e); setLoading(false);});
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
